import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FormWizardSteps } from 'src/app/models/shared-models';
import { VegWizardDataService } from 'src/app/veg-wizard/services/veg-wizard-data.service';
import { VegWizardStateMachineService } from 'src/app/veg-wizard/services/veg-wizard-state-machine.service';

@Injectable({
  providedIn: 'root',
})
export class CanActivateSelfAuditGuard implements CanActivate {
  constructor(public vwds: VegWizardDataService,
    public stateMachine: VegWizardStateMachineService,
    public router: Router) {}

  canActivate() {

    const dataState = this.vwds.getWizardDataState();

    const result = this.stateMachine.getSelfAuditRouteProperties(dataState);

    if (!result.isEnabled) {
      console.warn('CanActivateSelfAuditGuard - Required data does not exist!');

      if (dataState.isActivityPopulated) {
        this.router.navigate([FormWizardSteps.SelectActivity]);
        return false;
      }
      else {
        this.router.navigate(this.stateMachine.determineRouteNavigationForGuard());
        return false;
      }

    }

    return result.isEnabled;
  }

}
